export default "__VITE_ASSET__DsDDjcZw__"